export default "__VITE_ASSET__DLQhXf3o__"